import { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleLogin } from "@store/action/auth/AuthAction";
import { useTranslation } from "react-i18next";
// ** Styles
import "@styles/react/pages/page-authentication.scss";

const Login = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [remember_token, setRemember_token] = useState(true);
  const authReducer = useSelector((state) => state.auth);
  const onSubmit = () => {
    dispatch(handleLogin(email, password, remember_token));
  };
  useEffect(() => {
    if (authReducer.isAuth === true) {
      history.push("/admin/dashboard");
    }
    return()=>{
      $(function () {
        $('#login_modal').modal('toggle');
     });
    }
  }, [authReducer.isAuth]);

  return (
    <div
      className="modal  lang_ms_banner"
      id="login_modal"
      tabIndex="-1"
      aria-labelledby="login_modalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <button type="button" className="close" data-bs-dismiss="modal">
            ×
          </button>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="m24_language_box ms_cover">
                <h1>
                  {t("Login")} / {t("Sign in")}
                </h1>
                <p>{t("Welcome to Quantum!")} 👋</p>
                <p>
                  {t("Please sign-in to your account and start the adventure")}
                </p>
              </div>
              <p
                style={{
                  width: "100%",
                  fontSize: "1rem",
                  color: "#ea5455",
                  textAlign: "center",
                }}
              >
                {authReducer.error &&
                  authReducer.error.data?.length === 0 &&
                  authReducer.error.message}
              </p>
              <div className="login_form_wrapper">
                <div className="icon_form comments_form">
                  <input
                    autoFocus
                    type="text"
                    className="form-control"
                    name="full_name"
                    placeholder="Enter Email Address*"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <i className="fas fa-envelope" />
                  <p
                    style={{
                      width: "100%",
                      fontSize: "0.857rem",
                      color: "#ea5455",
                    }}
                  >
                    <span style={{ opacity: "0" }}>.</span>
                    {authReducer.error &&
                      authReducer.error.data &&
                      authReducer.error.data.email}
                  </p>
                </div>
                <div className="icon_form comments_form">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Enter Password *"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <p
                    style={{
                      width: "100%",
                      fontSize: "0.857rem",
                      color: "#ea5455",
                    }}
                  >
                    <span style={{ opacity: "0" }}>.</span>
                    {authReducer.error &&
                      authReducer.error.data &&
                      authReducer.error.data.password}
                  </p>

                  <i className="fas fa-lock" />
                </div>
                <div className="login_remember_box">
                  <label className="control control--checkbox">
                    {t("Remember me")}
                    <input
                      type="checkbox"
                      value={remember_token}
                      onChange={() => setRemember_token(true)}
                    />
                    <span className="control__indicator" />
                  </label>

                  <Link to="/admin/forgot-password" className="forget_password">
                    {t("Forgot Password?")}
                  </Link>
                </div>
              </div>
              <div className="lang_apply_btn_wrapper ms_cover">
                <div className="lang_apply_btn">
                  <a onClick={onSubmit}> {t("Sign in")}</a>
                </div>
                <div className="cancel_wrapper">
                  <a className="" data-dismiss="modal">
                    {t("Cancel")}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
